import {
    Drawer,
    DrawerContent,
    DrawerHeader,
    DrawerTitle,
} from '@rocco/components/drawer';
import ReturnsPolicyTemplate from './RefundTemplate';
import type { RefundPolicyData } from './RefundPolicy';

const RefundPolicyDialogMobile = ({
    open,
    close,
    data,
}: {
    open: boolean;
    close: () => void;
    data: RefundPolicyData;
}) => {
    return (
        <Drawer open={open} onOpenChange={(isOpen) => !isOpen && close()}>
            <DrawerContent scrollable limitMaxHeight>
                <DrawerHeader variant="border" alignment="left">
                    <DrawerTitle className="text-base font-semibold">
                        Return and Refund policy
                    </DrawerTitle>
                </DrawerHeader>
                <div className="overflow-y-auto px-5 py-6">
                    <ReturnsPolicyTemplate data={data} />
                </div>
            </DrawerContent>
        </Drawer>
    );
};

export default RefundPolicyDialogMobile;
